module.exports = __webpack_public_path__ + "img/paper_stack.f3f70d07.png";